import { defineEvent } from "@visioni/a3s-analytics";

/**
 * The camera a clip is from. Passed explicitly, because the player also runs on
 * screens whose route is not the clip's camera (dumping search, WasteSense,
 * scene compare). An `undefined` value falls back to the route context.
 */
export type ClipScope = {
  tenant_id: string | undefined;
  site_id: string | undefined;
  camera_key: string | undefined;
};

type ClipProps = ClipScope & { clip_id: string };

/** The clip player's mute toggle, on web and native. */
export const ClipMuted = defineEvent<ClipProps>("Clip Muted");
export const ClipUnmuted = defineEvent<ClipProps>("Clip Unmuted");

/** A clip downloaded from the camera's clips page (native only: the web clips page has no download button). */
export const ClipDownloaded = defineEvent<ClipProps>("Clip Downloaded");
